import { OtsApiOrderStatus, OtsStaffOrderStatus } from '../types';

export const OTS_STAFF_STATUS_FROM_API: Record<OtsApiOrderStatus, OtsStaffOrderStatus> = {
  Received: 'new',
  Preparing: 'preparing',
  OnTheWay: 'ready',
  ReadyForPickup: 'ready',
  Delivered: 'done'
};
